import { convertSnakeToCamelCase } from './stringHelper';

export type UserSourceData = {
  [key: string]: string | undefined;
  inviteToken?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  city?: string;
  countryCode?: string;
  date?: string;
  fileId?: string;
  fileName?: string;
  mobileCarrier?: string;
  ran?: string;
  referer?: string;
  regionCode?: string;
  source?: string;
  userAgent?: string;
  advertiserId?: string;
  advertiserRef?: string;
  affClickId?: string;
  affId?: string;
  affSub?: string;
  affSub2?: string;
  affSub3?: string;
  affSub4?: string;
  affSub5?: string;
  affUnique1?: string;
  affUnique2?: string;
  affUnique3?: string;
  affUnique4?: string;
  affUnique5?: string;
  affiliateId?: string;
  affiliateName?: string;
  affiliateRef?: string;
  offerFileId?: string;
  offerId?: string;
  offerName?: string;
  offerRef?: string;
  offerUrlId?: string;
  transactionId?: string;
  XPUtmSource?: string;
  XPUtmMedium?: string;
  XPUtmCampaign?: string;
  XPUtmTerm?: string;
  __func?: string;
  contactEmail?: string;
  title?: string;
  firstName?: string;
  lastName?: string;
  streetAddress?: string;
  streetAddress2?: string;
  contactCity?: string;
  state?: string;
  lang?: string;
  country?: string;
  socialToken?: string;
  gclid?: string;
  gadCampaignId?: string;
  gadSource?: string;
  gbraid?: string;
  bdVid?: string;
  qhclickid?: string;
  transId?: string;
  ttclid?: string;
  leadToken?: string;
};

export function extractUserSourceDataFromQueryString(
  params: Record<string, string | string[] | undefined>,
): UserSourceData {
  return Object.entries(params).reduce((acc, [key, value]) => {
    const newKey = convertSnakeToCamelCase(key) as keyof UserSourceData;
    if (key === 'invite') {
      return {
        ...acc,
        // Remap key
        inviteToken: value,
      };
    } else if (key === '__func') {
      return {
        ...acc,
        //  We don't want to camel case this
        __func: value,
      };
    } else if (Array.isArray(value)) {
      return {
        ...acc,
        [newKey]: decodeURIComponent(value[0]),
      };
    } else if (value !== undefined) {
      return {
        ...acc,
        [newKey]: decodeURIComponent(value),
      };
    } else {
      return acc;
    }
  }, {});
}
